import React from "react";
import "./Popup.css";

export default class Popup extends React.Component {
  render() {
    const className = this.props.className ? "popup__content--payment" : "";
    return (
      <div className="popup popup--overlay" onClick={this.props.onOverlayClick}>
        <button
          style={{
            width: "1px",
            height: "1px",
            position: "absolute",
            left: "50%",
            zIndex: "-10"
          }}
          tabIndex={0}
          autoFocus
          onKeyUp={this.props.onOverlayClick}
        />
        <div
          className={"popup__content " + className}
          onClick={e => e.stopPropagation()}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Popup/Popup.js